import { useIsFetching } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { SkeletonLoader } from '@unified-checkout/design-system';
import type { ISmsSubscribedPlanHistory } from '@app/dashboard/types/innerLayout/reach/bundles';

import { useLangStore } from '@app/dashboard/store/lang';
import { formatToISODate } from '@app/dashboard/utils/dateFormats';

import styles from './Header.module.scss';

const Header = ({
  currentPlan,
}: {
  currentPlan: ISmsSubscribedPlanHistory;
}) => {
  const { t } = useTranslation();
  const isFetching = useIsFetching();
  const { lang } = useLangStore();

  const { plan, expiration_date, expired } = currentPlan || {};

  const planName = lang === 'en' ? plan?.name_en : plan?.name_ar;
  const expirationDate = expiration_date
    ? formatToISODate(expiration_date)
    : null;

  return (
    <header className={styles['bundles__header']}>
      <h1 className={styles['bundles__header-title']}>
        {t('innerLayout.reach.bundles.heading')}
      </h1>

      <section className={styles['bundles__header-content']}>
        <h2 className={styles['bundles__header-content-title']}>
          {t('innerLayout.reach.bundles.title')}
        </h2>
        <p className={styles['bundles__header-content-subtitle']}>
          {t('innerLayout.reach.bundles.subtitle')}
        </p>
      </section>

      {!!isFetching ? (
        <SkeletonLoader noOfRows={2} height="80px" type="transparent_box" />
      ) : (
        planName &&
        expirationDate && (
          <div className={styles['bundles__header-active-plan']}>
            <p className={styles['bundles__header-active-plan-title']}>
              {t(
                `innerLayout.reach.bundles.${
                  expired ? 'selectNewBundle' : 'currentPlan'
                }`,
                {
                  plan: planName || '-',
                }
              )}
            </p>
            <p className={styles['bundles__header-active-plan-info-title']}>
              {t(
                `innerLayout.reach.bundles.${
                  expired ? 'yourBundleExpiredOn' : 'expirationDate'
                }`,
                {
                  date: expirationDate || '-',
                }
              )}
            </p>
          </div>
        )
      )}
    </header>
  );
};

export default Header;
